import React from "react";

import { ProductDetails } from "components/ProductDetails";

const ProductDetailsPage = () => {
  return <ProductDetails />;
};
export default ProductDetailsPage;
